/**
 * Module dependencies.
 */

import { fetchGraphql } from 'utils/fetch-graphql';
import { normalizeSingleObject } from 'utils/normalizers';
import { pickSocialNetworks } from 'utils/social-networks';

/**
 * Query.
 */

const QUERY = `
    query {
      Company {
        facebook
        instagram
        twitter
        pinterest
        linkedin
        youtube
        address
        email
        phonePT
        phoneEN
        phoneFR
        latitude
        longitude
        translations {
          languages_code {
            code
          }
          schedule
        }
      }
    }
  `;

/**
 * Export `contactsStaticProps`.
 */

export function contactsStaticProps() {
  try {
    return fetchGraphql(QUERY).then((data) => {
      const result: any = {};

      result.company = normalizeSingleObject(data.Company);
      result.socialNetworks = pickSocialNetworks(data.Company);

      return result;
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    throw error;
  }
}
